module.exports = __webpack_public_path__ + "static/img/car.44ed2b0d.jpg";